module.exports = __webpack_public_path__ + "img/active-patient.cb692357.png";